import { Dispatch, SetStateAction } from 'react';

import Typography from '@components/Typography';

import {
  Container,
  Wrapper,
  Title,
  Description,
  ButtonContainer,
  EvaluationButton,
  CloseButton,
} from './styled';

export const SurveyModal = ({
  setIsSurveyOpen,
  setIsSurveyModalOpen,
  toggleChatGPTModal,
  setIsSurveyClick,
}: {
  setIsSurveyOpen: Dispatch<SetStateAction<boolean>>;
  setIsSurveyModalOpen: Dispatch<SetStateAction<boolean>>;
  setIsSurveyClick: Dispatch<SetStateAction<boolean>>;
  toggleChatGPTModal: () => void;
}) => {
  return (
    <Container onClick={(e) => e.stopPropagation()}>
      <Wrapper>
        <Title>Setur Seyahat Asistanı</Title>
        <Description>
          Seyahat asistanı deneyiminizi değerlendirmek ister misiniz?
        </Description>
        <ButtonContainer>
          <CloseButton
            onClick={() => {
              setIsSurveyOpen?.(false);
              toggleChatGPTModal();
            }}
            variant='Default'
          >
            <Typography variant='caption2' weight='Bold' color='D300'>
              Kapat
            </Typography>
          </CloseButton>
          <EvaluationButton
            onClick={() => {
              setIsSurveyModalOpen?.(true);
              setIsSurveyClick?.(true);
              setIsSurveyOpen?.(false);
            }}
            variant='Primary'
          >
            <Typography variant='caption2' weight='Bold' color='NL0'>
              Değerlendir
            </Typography>
          </EvaluationButton>
        </ButtonContainer>
      </Wrapper>
    </Container>
  );
};

export default SurveyModal;
